import React from 'react'
import { useParams} from 'react-router-dom'
import ProductContent from '../components/ProductContent/ProductContent'

const ProductItem = () => {
  const {id} = useParams<{id: string}>()
  return (
    <main>
        {id ? <ProductContent productId={id}/> : <div className='container'>
            <span className='product-item-error'>Product was not found</span>
          </div>}
    </main>
  )
}

export default ProductItem